export const isSafeInternalPath = (value: unknown): value is string => {
  if (typeof value !== "string") return false;
  if (!value.startsWith("/")) return false;
  if (value.startsWith("//")) return false;
  return true;
};

export const buildUserProfileFromPath = (
  pathname: string,
  search = "",
  hash = "",
): string | undefined => {
  const currentPath = `${pathname}${search}${hash}`;
  if (currentPath.startsWith("/user-profile/")) {
    return undefined;
  }
  return currentPath;
};
